import React from 'react';
import { CalendarDaysIcon } from '@heroicons/react/24/outline';
import { getOrganismeLogo } from '../utils/agendaHelpers';

export default function AgendaReunionLogo({ organisme, size = 'md' }) {
  const logo = getOrganismeLogo(organisme);
  const boxClass = size === 'lg'
    ? 'w-20 h-20'
    : 'w-16 h-16';
  const imgClass = size === 'lg'
    ? 'max-h-14 max-w-[88%] object-contain'
    : 'max-h-11 max-w-[88%] object-contain';

  if (!logo) {
    return (
      <div className={`flex-shrink-0 ${boxClass} rounded-lg bg-honey-50 flex items-center justify-center`}>
        <CalendarDaysIcon className={`${size === 'lg' ? 'h-6 w-6' : 'h-5 w-5'} text-honey-500`} />
      </div>
    );
  }

  return (
    <div className={`flex-shrink-0 ${boxClass} rounded-lg bg-white border border-slate-100 flex items-center justify-center overflow-hidden p-1.5`}>
      <img
        src={logo}
        alt={organisme || 'Réunion'}
        className={imgClass}
      />
    </div>
  );
}
